import { routes } from '@app/constant';
import { useAppSelector } from '@state/configureStore';
import { selectUserRole } from '@state/pageSlice';
import { UserRole } from '@state/userApi';
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface RoleProtectedRouteProps {
    allowedRoles?: UserRole[];
}

export const RoleProtectedRoute: FC<RoleProtectedRouteProps> = ({ allowedRoles }) => {
    const userRole = useAppSelector(selectUserRole);

    // If no roles are specified or user has no role, allow access
    if (!allowedRoles || allowedRoles.length === 0 || !userRole) {
        return <Outlet />;
    }

    // Check if user's role is in the allowed roles list
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to={routes.learning} replace />;
    }

    return <Outlet />;
};
